import { render, staticRenderFns } from "./chatFooter.vue?vue&type=template&id=35052552&scoped=true"
import script from "./chatFooter.vue?vue&type=script&lang=js"
export * from "./chatFooter.vue?vue&type=script&lang=js"
import style0 from "./chatFooter.vue?vue&type=style&index=0&id=35052552&prod&lang=scss&scoped=true"
import style1 from "./chatFooter.vue?vue&type=style&index=1&id=35052552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35052552",
  null
  
)

export default component.exports